import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { PipaylibService } from 'pipaylib';
import { Distyconfig } from 'pipaylib/domain/distyconfig';
import { toWords } from 'number-to-words';
import { Distributor } from 'pipaylib/domain/distributor';
import { Distyretailer } from 'pipaylib/domain/distyretailer';
import { jsPDF } from 'jspdf';
import domtoimage from 'dom-to-image';
import { LoadingController } from '@ionic/angular';
import * as pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts'; // Use default export if available
pdfMake.vfs = pdfFonts?.vfs || pdfFonts.pdfMake?.vfs;
// import { Filesystem, Directory } from '@capacitor/filesystem';
// import { FileOpener } from '@capacitor-community/file-opener';
import * as FileSaver from 'file-saver';
import { AppdataService } from 'src/app/services/appdata.service';

// pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-orderbill',
  templateUrl: './orderbill.component.html',
  styleUrls: ['./orderbill.component.scss'],
})
export class OrderbillComponent implements OnInit, OnChanges {
  @ViewChild('page') page: HTMLElement | null = null;
  @Input() selectedOrder: any;
  @Input() showBill: boolean;
  curconfig: Distyconfig;
  distributor: Distributor;
  retailer: Distyretailer;
  receivableAmountInWords: string;
  fetching: boolean;
  base64ImageLogo: string | ArrayBuffer | null = null;
  constructor(private pipaylib: PipaylibService, public loadingCtrl: LoadingController, private dataService: AppdataService,) { }

  ngOnChanges(changes: SimpleChanges): void {
    if ('selectedOrder' in changes) {
      this.selectedOrder = changes.selectedOrder.currentValue;
      console.log('selected order changed to', this.selectedOrder);
      this.retailer = this.pipaylib.dataService.getRetailerForId(this.selectedOrder?.distyretailerid);
      if (this.selectedOrder && this.selectedOrder.cart) {
        this.showLoader('Generating bill...');
        this.receivableAmountInWords = toWords(this.selectedOrder.cart.payableamount);
        setTimeout(() => {
          console.log(this.curconfig.distylogofile);
          // this.sendPDF(this.selectedOrder);
          // this.urlToDataUri(this.curconfig.distylogofile)
          // .then(base64String => {
          //     console.log(base64String); // Base64 representation of the image
          // })
          // .catch(error => {
          //     console.error('Error:', error);
          // });
          this.generatePDF();
          this.hideLoader();
        }, 1000);
      }
    }
  }

  ngOnInit() {
    this.curconfig = this.pipaylib.loginService.loggedindistributor.distyconfig;
    this.distributor = this.pipaylib.loginService.loggedindistributor;
  }

  async sendPDF(record: any){
    const retailer = this.pipaylib.dataService.getRetailerForId(record.distyretailerid);
    this.page = document.getElementById('page');
    const pageHeight = 1080;
    const pageWidth = 1920;
    const options = {
      background: 'white',
      width: pageWidth,
      height: pageHeight,
    };
    domtoimage.toPng(this.page, options).then(async (imgData) => {
      const pdfHeightInPoints = pageHeight * 0.75;
      const pdfWidthInPoints = pageWidth * 0.75;

      const doc = new jsPDF('l', 'pt', [pdfWidthInPoints, pdfHeightInPoints]);
      const imgProps = doc.getImageProperties(imgData);
      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      doc.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      const filename = 'Invoice_' + this.pipaylib.loginService.loggedindistributor.id + '_' + new Date().getTime() + '.pdf';
      const blob = doc.output('blob');
      // const billpdffile = new File([blob], filename, { type: 'application/pdf' });
      const billpdffile = new Blob([blob], { type: 'application/pdf' }) as File;
      const ret = await this.pipaylib.solace.utilService.uploadFiletoS3( billpdffile,filename,'foodkartiposimages');
      console.log(`https://s3.ap-south-1.amazonaws.com/foodkartiposimages/${filename}`);
      this.showBill = false;
      // if (ret) {
      //   const pdfurl = 'https://s3.ap-south-1.amazonaws.com/foodkartiposimages/' + filename;
      //   const ord = record;
      //   this.pipaylib.invoiceService.sendBillOnWhatsApp(ord.billseq, retailer.mobileno,
      //     pdfurl, filename, retailer.businessname, ord.cart.payableamount.toFixed(2));
      // }
    });
  }

  hideLoader() {
    if (this.fetching) {this.fetching = false;}
    return this.loadingCtrl
      .dismiss()
      .catch((e) => console.log(e));
  }

  showLoader(msg) {
    if (!this.fetching) {this.fetching = true;}
    return this.loadingCtrl
      .create({
        message: msg,
        spinner: 'bubbles',
      })
      .then((res) => {
        res.present().then(() => {
          if (!this.fetching) {
            res.dismiss().then(() => {
            });
          }
        });
      })
      .catch((e) => {
        this.fetching = false;
      });
  }

  async generatePDF() {
    const pdfContent = this.getPDFContent();
    const pdfDocGenerator = pdfMake.createPdf(pdfContent);
    const pdfname = 'Invoice_' + new Date().getTime() + '.pdf';
    pdfDocGenerator.getBlob(async (blob) => {
      // const billpdffile = new File([blob], pdfname, { type: 'application/pdf' });
      const billpdffile = new Blob([blob], { type: 'application/pdf' }) as File;
      const ret = await this.pipaylib.solace.utilService.uploadFiletoS3( billpdffile,pdfname,'foodkartiposimages');
      // FileSaver.saveAs(blob, pdfname);
      if (ret) {
        const pdfurl = 'https://s3.ap-south-1.amazonaws.com/foodkartiposimages/' + pdfname;
        const ord = this.selectedOrder;
        this.pipaylib.invoiceService.sendBillOnWhatsApp(ord.billseq, this.retailer.mobileno,
          pdfurl, pdfname, this.retailer.businessname, ord.cart.payableamount.toFixed(2));
      }
    });
  }

  convertToBase64(fileUrl: string) {
    fetch(fileUrl)
      .then(res => res.blob())
      .then(blob => {
        const fileReader = new FileReader();
        fileReader.onload = () => {
          this.base64ImageLogo = fileReader.result;
          // You can now use this.base64Image in your component
        };
        fileReader.readAsDataURL(blob);
      })
      .catch(error => {
        console.error('Error converting file to base64:', error);
      });
  }

  getPDFContent() {
    // this.convertToBase64(this.curconfig.distylogofile);
    return {
      content: [
        {
          columns: [
            [
              // {
              //   image: this.base64ImageLogo,
              //   width: 60,
              //   alignment: 'left',
              //   margin: [0, 10]
              // },
              { text: 'Tax Invoice', style: 'header', alignment: 'center', margin: [0, 10], bold: true },
            ]
          ]
        },
        {
          columns: [
            {
              width: '100%',
              stack: [
                {
                  text: `Bill No: ${this.selectedOrder.billseq ? this.selectedOrder.billseq : ''}`,
                  style: 'Rsubheader',
                  alignment: 'right',
                  bold: true
                },
                { text: `Date: ${this.selectedOrder.orderdate}`, style: 'Rsubheader', alignment: 'right' },
                { text: `Salesman: ${this.selectedOrder.salesstaffname}`, style: 'Rsubheader', alignment: 'right', margin: [0, 0, 0, 10] }
              ]
            }
          ]
        },
        {
          columns: [
            {
              width: '60%',
              stack: [
                { text: this.distributor.businessname, style: 'Lsubheader', bold: true },
                `${this.distributor.addressline1} ${this.distributor.addressline2}`,
                `Contact: ${this.distributor.mobileno}`,
                `GSTIN: ${this.distributor.gstinno}`,
                `GST State: ${this.distributor.statename}`,
                `PAN: ${this.distributor.panno}`,
              ],
            },
            {
              width: '40%',
              stack: [
                { text: this.selectedOrder.distyretailername, style: 'Rsubheader', bold: true, alignment: 'right' },
                { text: `${this.retailer.addressline1 ? this.retailer.addressline1 : ''} ${this.retailer.addressline2 ? this.retailer.addressline2 : ''}`, alignment: 'right' },
                { text: `Contact: ${this.retailer.mobileno}`, alignment: 'right' },
                { text: `GSTIN: ${this.retailer.gstinno ? this.retailer.gstinno : ''}`, alignment: 'right' },
                { text: `GST State: ${this.retailer.gststate ? this.retailer.gststate : ''}`, alignment: 'right' },
                { text: `PAN: ${this.retailer.panno ? this.retailer.panno : ''}`, alignment: 'right' }
              ]
            }
          ]
        },
        {
          style: 'tableTitle',
          margin: [0, 10, 0, 10],
          table: {
            headerRows: 1,
            widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: [
              ['S.No', 'Product Name', 'Qty', 'UOM', 'Rate', 'Discount', 'Taxable Amount', 'GST Rate', 'CESS Rate', 'Taxes'],
              ...this.selectedOrder.cart.items.map((item, index) => [
                index + 1,
                `${item.productname}${item.hsnno ? `\nHSN: ${item.hsnno}` : ''}${item.narration ? `\n${item.narration}` : ''}`,
                item.actquantity,
                item.uom,
                item.rate.toFixed(2),
                item.disc.toFixed(2),
                item.billedamount.toFixed(2),
                `${item.gstrate}%`,
                `${item.cessrate}%`,
                (item.cgst + item.sgst + item.igst + item.cess) ? item.cgst + item.sgst + item.igst + item.cess : 0
              ])
            ]
          }
        },
        {
          columns: [
            {
              width: '70%',
              stack: [
                { text: 'GST Bifurcation Details:', style: 'Lsubheader' },
                {
                  table: {
                    headerRows: 1,
                    widths: ['*', 'auto', 'auto', 'auto', 'auto'],
                    body: [
                      ['GST%', 'CGST', 'SGST', 'IGST', 'CESS'],
                      ...this.selectedOrder.cart.gstbifurcationlist.map(gstb => [
                        `${gstb.gstrate ? gstb.gstrate : 0.00}%`,
                        gstb.cgstamount ? gstb.cgstamount.toFixed(2) : 0.00,
                        gstb.sgstamount ? gstb.sgstamount.toFixed(2) : 0.00,
                        gstb.igstamount ? gstb.igstamount.toFixed(2) : 0.00,
                        gstb.gstrate === 28 ? this.selectedOrder.cart.cess.toFixed(2) : 0.00
                      ])
                    ],
                    margin: [0, 0, 20, 0]
                  }
                }
              ]
            },
            {
              width: '30%',
              stack: [
                { text: 'Summary:', style: 'Rsubheader', alignment: 'right' },
                { text: `Item Amount: ${this.selectedOrder.cart.itemamount.toFixed(2)}`, style: 'Rsubheader', alignment: 'right' },
                { text: `Total Discount: ${this.selectedOrder.cart.totaldisc.toFixed(2)}`, style: 'Rsubheader', alignment: 'right' },
                { text: `Total CGST: ${this.selectedOrder.cart.cgst ? this.selectedOrder.cart.cgst.toFixed(2) : 0.00}`, style: 'Rsubheader', alignment: 'right' },
                { text: `Total SGST: ${this.selectedOrder.cart.sgst ? this.selectedOrder.cart.sgst.toFixed(2) : 0.00}`, style: 'Rsubheader', alignment: 'right' },
                { text: `Round Off: ${this.selectedOrder.cart.roundingamt.toFixed(2)}`, style: 'Rsubheader', alignment: 'right' },
              ]
            }
          ]
        },
        {
          columns: [
            {
              width: '100%',
              stack: [
                { text: `In Words: ${this.receivableAmountInWords.toUpperCase()}`, alignment: 'left', margin: [0, 10] },
                {
                  text: 'Declaration: We here by certify that food/foods mentioned in this invoice is/are warranted to be the nature and quality which they purport to be.',
                  alignment: 'left',
                  margin: [0, 10],
                  fontSize: 12
                },
              ]
            }
          ]
        },
        {
          columns: [
            [
              { text: 'Customer Signature', style: 'header', alignment: 'right', margin: [0, 10], bold: true },
            ]
          ]
        },
        {
          columns: [
            {
              width: '30%',
              stack: [
                { text: '(E.O.E)', style: 'Lsubheader', margin: [0, 10], bold: true },
              ]
            },
            {
              width: '45%',
              stack: [
                { text: `CHQ RETURN CHARGE ${this.curconfig.failurecharges}`, style: 'Lsubheader', margin: [0, 10] },
              ]
            },
            {
              width: '25%',
              stack: [
                { text: 'For: Pipay Tally Test', style: 'Lsubheader', margin: [0, 10], bold: true, alignment: 'right' },
              ]
            }
          ]
        }
      ],
    };
  }

  async urlToDataUri(url: string): Promise<string> {
    const response = await fetch(url);
    const blob = await response.blob();
    const reader = new FileReader();
    return new Promise<string>((resolve, reject) => {
        reader.onerror = reject;
        reader.onload = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result);
            } else {
                reject(new Error('Failed to convert image to Data URI'));
            }
        };
        reader.readAsDataURL(blob);
    });
}
}
